<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="500">
    <template v-slot:title>Update Allocations</template>
    <v-row>
      <v-col>
        <v-text-field
          v-model="total"
          label="New Total"
          :outlined="outlinedInputs"
          type="number"
          :rules="qtyRules"
        />
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <code>{{ minQty }}</code>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import { sortByFn } from "../../../../helpers";
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "edit-allocations-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    allocations: {
      type: Array,
      default: () => [],
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      total:
        this.allocations.length > 0
          ? this.allocations.sort(sortByFn((a) => parseInt(a.qty))).reverse()[0]
              .qty
          : 0,
      qtyRules: [
        (v) => !!v || "This field is required",
        (v) =>
          (v && v >= this.minQty) ||
          "NEW TOTAL IS LESS THAN REMAINING FOR SOME SELECTED ALLOCATONS. REVIEW YOUR SELECTION AND TRY AGAIN",
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    minQty() {
      if (this.allocations.length > 0) {
        const sorted = this.allocations.sort(
          sortByFn((a) => parseInt(a.remaining))
        );
        return parseInt(sorted.reverse()[0].remaining);
      } else {
        return 0;
      }
    },
    isValid() {
      return parseInt(this.total) >= this.minQty;
    },
  },

  methods: {
    onSave() {
      this.$emit("save", { qty: parseInt(this.total) });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/allocations/EditAllocationsDialog.vue